import React from 'react'
import { useHistory } from 'react-router-dom'

import { Container } from './styles'

type IProps = any & {
  title: string;
  href: string;
  submittingText: string;
  isSubmitting: boolean;
  withDisable: boolean;
}

const Button = ({
  title,
  href,
  withDisable,
  el,
}: IProps): JSX.Element => {
  const history = useHistory()
  const disabledAttr = withDisable
    ? { disabled: !(el.isValid && el.dirty) }
    : {}

  const goTo = () => {
    history.push(href)
  }

  return (
    <Container onClick={goTo} type="button" {...disabledAttr}>{title}</Container>
  )
}

export default Button
